import React, { useState } from "react";
import Button from "../../../../components/shared/Button/Button";
import Divider from "../../../../components/shared/Divider/Divider";
import { swingCollectionsService } from "../../../../services/swingCollections";
import { useHistory } from "react-router-dom";
import { useInvalidate } from "../../../../hooks/useInvalidate";
import { toast } from "react-toastify";
import IconBadge from "../../../../components/shared/IconBadge";
import ModalMobile from "../../../../components/shared/Modal/ModalMobile";
import { MdInfoOutline } from "react-icons/md";

export default function DeleteCollectionModal({
  collectionId,
  isOpen,
  onClose,
}) {
  const invalidate = useInvalidate();
  const history = useHistory();
  const [isLoading, setIsLoading] = useState(false);

  const handleDelete = async () => {
    if (!collectionId) return;
    try {
      setIsLoading(true);
      await swingCollectionsService.deleteSwingCollection({
        collectionId: collectionId,
      });
      await invalidate(["getAllSwingCollectionsByUserId_key"]);
      toast.success("Collection deleted");
      if (onClose) onClose();

      history.push("/collections");
    } catch (e) {
      console.error("[Collection] delete failed:", e);
      toast.error("Failed to delete collection");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <ModalMobile
      className="w-full max-w-lg overflow-hidden p-0"
      isOpen={isOpen}
      onClose={onClose}
      showClose={true}
    >
      <div className="p-6">
        <IconBadge
          className="mb-4"
          icon={MdInfoOutline}
          iconColor="error600"
          innerColor="error100"
          outerColor="error50"
          size="lg"
        />
        <div className="flex flex-col gap-3">
          <div className="text-lg font-semibold text-black">
            Are you sure you want to permanently delete this collection?
          </div>
          <div className="text-gray600 text-sm">
            All swings in this collection will be removed from this collection,
            this change cannot be reverted
            <br />
            <br />
            Do you wish to continue?
          </div>
        </div>
      </div>

      <Divider color="gray200" type="horizontal" />

      <div className="grid grid-cols-2 items-center gap-3 p-6">
        <Button
          color="gray100"
          isDisabled={isLoading}
          onClick={onClose}
          size="md"
        >
          Keep Collection
        </Button>

        <Button
          color="error600"
          isDisabled={isLoading}
          onClick={handleDelete}
          size="md"
        >
          {isLoading ? "Deleting…" : "Permanently Delete"}
        </Button>
      </div>
    </ModalMobile>
  );
}
